import { render, staticRenderFns } from "./regionManager.vue?vue&type=template&id=6aa4a233&scoped=true&"
import script from "./regionManager.vue?vue&type=script&lang=js&"
export * from "./regionManager.vue?vue&type=script&lang=js&"
import style0 from "./regionManager.vue?vue&type=style&index=0&id=6aa4a233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4a233",
  null
  
)

export default component.exports